<template>
  <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none" tabindex="0">
    <div class="py-6" ref="scrollDiv">
      <div class="mx-auto px-4 sm:px-6 md:px-8 flex flex-row">
        <div class="flex-1 flex flex-row space-y-3 items-end mb-5 space-x-2">
          <div class="space-y-1 flex-1">
            <label for="searchText" class="block text-sm font-medium text-gray-700">Search Query
            </label>
            <input type="text" name="searchText" id="searchText"
              placeholder="Search by a title, keyword, tag, or YouTube ID..."
              class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
              v-model="searchQuery" />
          </div>
          <div class="space-y-1">
            <label for="date" class="block text-sm font-medium text-gray-700">Date (optional)
            </label>
            <input type="date" name="date" id="date"
              class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
              v-model="searchDate" />
          </div>

          <div class="space-y-1">
            <label for="user" class="block text-sm font-medium text-gray-700">User
            </label>
            <select
              class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              v-model="userId" id="user" name="user">
              <option :value="null">All</option>
              <option v-for="stringer in stringers" :value="stringer.id" v-bind:key="stringer.id">{{ stringer.name }}
              </option>
            </select>
          </div>

          <div class="space-y-1">
            <label for="sort" class="block text-sm font-medium text-gray-700">Sort
            </label>
            <select
              class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              v-model="searchFilter" name="sort" id="sort">
              <option value="desc">Newest First</option>
              <option value="asc">Oldest First</option>
            </select>
          </div>
          <div class="space-x-2">
            <button class="px-4 py-2 bg-gray-200 rounded-md focus:outline-none" v-on:click="resetButtonClick()">
              Reset
            </button>
            <!-- <button
            class="px-4 py-2 bg-blue-600 rounded-md text-white focus:outline-none"
          >
            Search
          </button> -->
          </div>
        </div>
        <div class="flex flex-1 flex-row items-center justify-end invisible lg:visible">
          <div class="mr-4"><i class="fad fa-th-large text-2xl"></i></div>
          <input class="range-slider__range w-0 md:w-48" type="range" :min="1" :max="4" v-model="gridCol" />
          <div class="ml-4"><i class="fad fa-th text-2xl"></i></div>
        </div>
      </div>
      <div class="w-full h-full w-full text-center" v-if="loading">
        <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
      </div>
      <div class="mx-auto px-4 sm:px-6 md:px-8 mt-4">
        <div class="grid gap-4 grid-cols-1" :class="['lg:grid-cols-' + gridCol]">
          <VideoCard v-for="video in videos" v-bind:key="'search-' + video.id" :video="video" />
        </div>
        <div ref="loadMoreDivSearch" class="h-10"></div>
      </div>
    </div>
  </main>
</template>

<script>
import * as Config from "@/config";

import { mapActions } from "vuex";
import VideoCard from "@/components/VideoCard";

export default {
  name: "MediaSearch",
  data() {
    return {
      videos: [],
      resource_url: Config.apiPath + "/api/v2/media/search/videos",
      index: 1,

      loading: false,
      hasSearched: false,

      searchQuery: "",
      current_page: 1,
      last_page: null,
      searching: false,

      orderByStatus: "desc",
      searchDebounce: null,

      gridCol: 3,

      bottom: false,
      showVideoPopover: false,
      shouldLoadMore: null,

      searchFilter: "desc",
      searchDate: null,
      stringers: [],
      userId: null
    };
  },
  components: { VideoCard },
  created() {
    this.$nextTick(() => {
      this.search();
      this.getStringers();

      this.$eventBus.$on("scroll", () => {
        this.handleScroll();
      });
      this.shouldLoadMore = setInterval(
        function () {
          this.handleScroll();
        }.bind(this),
        250
      );
    });
  },
  destroyed() {
    this.$eventBus.$off("scroll");
    clearInterval(this.shouldLoadMore);
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.search();
      }
    },
    searchQuery: function () {
      this.reset();
      this.searching = true;
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.index = 1;
        this.search();
      }, 600);
    },
    searchFilter: function () {
      this.reset();
      this.searching = true;
      this.index = 1;
      this.search();
    },
    userId: function () {
      this.reset();
      this.searching = true;
      this.index = 1;
      this.search();
    }
  },
  methods: {
    ...mapActions(["addToastMessage"]),
    async search() {
      let url = this.computeResourceUrl();

      try {
        let res = await this.$http.get(url);
        this.current_page = res.data.current_page + 1;
        this.videos = this.videos.concat(res.data.data);
        this.bottom = false;
        this.index += 1;
        this.last_page = res.data.last_page;
        this.searching = false;
        this.fetching = false;
      } catch (e) {
        this.searching = false;
        this.fetching = false;
        this.addToastMessage({
          title: "Error",
          text: "We have encountered an error loading more videos, try again.",
          type: "error"
        });
      }
    },

    orderBy(value) {
      this.orderByStatus = value;
      this.search();
    },

    computeResourceUrl() {
      var baseURL = this.resource_url + "?page=" + this.current_page;

      if (this.searchQuery !== "" && this.searchQuery !== null) {
        baseURL += "&search=" + this.searchQuery;
      }

      if (this.userId !== "" && this.userId !== null) {
        baseURL += "&userId=" + this.userId;
      }

      if (this.searchFilter !== null) {
        baseURL += "&orderBy=" + this.searchFilter;
      }

      return baseURL;
    },
    bottomVisible() {
      const rect = this.$refs.loadMoreDivSearch.getBoundingClientRect();

      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
        (window.innerWidth || document.documentElement.clientWidth);

      return isInViewport;
    },
    handleScroll() {
      this.bottom = this.bottomVisible();
    },
    toggleVideoPopver() {
      this.showVideoPopover = !this.showVideoPopover;
    },
    async getStringers() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/media/stringer-roster"
      );
      this.$set(this, "stringers", res.data);
    },
    reset() {
      this.current_page = 1;
      this.index = 1;
      this.videos = [];
    }
  }
};
</script>
